import { createTheme } from '@mui/material';

const theme = {
    palette: {
        primary: {
            // light: will be calculated from palette.primary.main,
            light: '#a4d0e4',
            main: '#0e57b6',
            dark: '#507a87',
            contrastText: '#ea9b2a',
            // dark: will be calculated from palette.primary.main,
            // contrastText: will be calculated to contrast with palette.primary.main
        },
        secondary: {
            // light: will be calculated from palette.primary.main,
            main: '#507a87',
            // dark: will be calculated from palette.secondary.main,
            // contrastText: will be calculated to contrast with palette.primary.main
        },
        // Custom semantic colors for news actions
        publish: {
            main: '#18bc9c',
            contrastText: '#ffffff',
        },
        scheduled: {
            main: '#f39c12',
            contrastText: '#ffffff',
        },
        draft: {
            main: '#0e57b6',
            contrastText: '#ffffff',
        },
        warning: {
            main: '#f39c12',
            contrastText: '#ffffff',
        },
        // Provide every color token (light, main, dark, and contrastText) when using
        // custom colors for props in Material UI's components.
        // Then you will be able to use it like this: `<Button color="custom">`
        // (For TypeScript, you need to add module augmentation for the `custom` value)
        custom: {
            main: '#e9852d',
        },
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold: 3,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset: 0.2,
    },
}

const DainTheme = {
    light: createTheme(theme),
    dark: createTheme({
        palette: { ...theme.palette, mode: 'dark' }
    })
}

export default DainTheme;